<template>
  <FormContainer class="settings-form" @submitForm="saveSettings">
    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Impostazioni previsionale</h4>
      <FormInputMonthPickerWidget
        v-if="edit && settings.isPrimary"
        class="col-sm-6 col-lg-3 mb-3"
        label="Inizio previsionale"
        v-model="settings.inizioPrevisionale"
        :errorMsg="errorHash.inizioPrevisionale"
        @input="removeError('inizioPrevisionale')"
      />

      <FormInputTextWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Durata previsionale"
        appendText="anni"
        type="number"
        min="3" max="5"
        v-model.number="settings.durataPrevisionale"
        :errorMsg="errorHash.durataPrevisionale"
        @input="removeError('durataPrevisionale')"
      />

      <FormInputSelectWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Mesi di budget"
        v-model.number="settings.mesiDiBudget"
        :options="budgetMonthsOpts"
        optionValue="value"
      />
    </div>

    <div v-if="hasProjects" class="row pt-4">
      <h4 class="h2 col-12">Previsionale progetti</h4>
      <FormInputAmountWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Previsione di ricavi annui"
        v-model.number="settings.previsioneRicaviProgetti"
        :min="0"
        :errorMsg="errorHash['previsioneRicaviProgetti']"
        @input="removeError('previsioneRicaviProgetti')"
      />
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Aliquota iva media su ricavi"
        v-model="settings.previsioneRicaviAliquotaIvaProgetti"
        :errorMsg="errorHash.previsioneRicaviAliquotaIvaProgetti"
        @input="removeError('previsioneRicaviAliquotaIvaProgetti')"
      />
    </div>
    <div v-if="hasProjects" class="row pb-4 border-bottom">
      <FormInputAmountWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Previsione di costi annui"
        v-model.number="settings.previsioneCostiProgetti"
        :min="0"
        :errorMsg="errorHash['previsioneCostiProgetti']"
        @input="removeError('previsioneCostiProgetti')"
      />
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Aliquota iva media su costi"
        v-model="settings.previsioneCostiAliquotaIvaProgetti"
        :errorMsg="errorHash.previsioneCostiAliquotaIvaProgetti"
        @input="removeError('previsioneCostiAliquotaIvaProgetti')"
      />
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Aliquota ritenuta media su costi"
        v-model="settings.previsioneCostiAliquotaRitenutaProgetti"
        :errorMsg="errorHash.previsioneCostiAliquotaRitenutaProgetti"
        @input="removeError('previsioneCostiAliquotaRitenutaProgetti')"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Inflazione</h4>

      <!-- Costs Inflation -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Inflazione costi"
        v-model="settings.inflazioneCosti"
        :errorMsg="errorHash.inflazioneCosti"
        @input="removeError('inflazioneCosti')"
      />

      <!-- Revenues Inflation -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Inflazione ricavi"
        v-model="settings.inflazioneRicavi"
        :errorMsg="errorHash.inflazioneRicavi"
        @input="removeError('inflazioneRicavi')"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Gestione ammortamento</h4>

      <!-- Super Amortization Increase -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Maggiorazione super-ammortamento"
        v-model="settings.maggiorazioneSuperAmmortamento"
        :errorMsg="errorHash.maggiorazioneSuperAmmortamento"
        @input="removeError('maggiorazioneSuperAmmortamento')"
      />

      <!-- Hyper Amortization Increase -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Maggiorazione iper-ammortamento"
        v-model="settings.maggiorazioneIperAmmortamento"
        :errorMsg="errorHash.maggiorazioneIperAmmortamento"
        @input="removeError('maggiorazioneIperAmmortamento')"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Gestione Fiscale</h4>
      <!-- VAT cycle -->
      <FormInputSelectWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Periodicità IVA"
        v-model="settings.periodicitaIva"
        :options="vatCycleOptions"
        optionValue="value"
      />

      <!-- IRES Quota  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Aliquota ires"
        v-model="settings.aliquotaIres"
        :errorMsg="errorHash.aliquotaIres"
        @input="removeError('aliquotaIres')"
      />

      <!-- IRAP Quota  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Aliquota irap"
        v-model="settings.aliquotaIrap"
        :errorMsg="errorHash.aliquotaIrap"
        @input="removeError('aliquotaIrap')"
      />

      <!-- Deducible IRAP  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="IRAP deducibile"
        v-model="settings.irapDeducibile"
        :errorMsg="errorHash.irapDeducibile"
        @input="removeError('irapDeducibile')"
      />

      <!-- First Deposit Precentage  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Percentuale primo anticipo"
        v-model="settings.percentualePrimoAnticipo"
        :errorMsg="errorHash.percentualePrimoAnticipo"
        @input="removeError('percentualePrimoAnticipo')"
      />

      <!-- Second Deposit Precentage  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Percentuale secondo anticipo"
        v-model="settings.percentualeSecondoAnticipo"
        :errorMsg="errorHash.percentualeSecondoAnticipo"
        @input="removeError('percentualeSecondoAnticipo')"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Dati finanziari</h4>
      <!-- Operative Credit Average Rate  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Tasso medio credito operativo"
        v-model="settings.tassoMedioCreditoOperativo"
        :errorMsg="errorHash.tassoMedioCreditoOperativo"
        @input="removeError('tassoMedioCreditoOperativo')"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Costo del Lavoro</h4>
      <!-- Social Taxes On Annual Revenue  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Oneri sociali su RAL"
        v-model="settings.oneriSocialiSuRal"
        :errorMsg="errorHash.oneriSocialiSuRal"
        @input="removeError('oneriSocialiSuRal')"
      />

      <!-- Average INPS Withholdings  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Trattenute INPS medie"
        v-model="settings.trattenuteInpsMedie"
        :errorMsg="errorHash.trattenuteInpsMedie"
        @input="removeError('trattenuteInpsMedie')"
      />

      <!-- Severance Pay Funds  -->
      <FormInputPercentageWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Accantonamenti TFR su Salari"
        v-model="settings.accantonamentiTfrSalari"
        :errorMsg="errorHash.accantonamentiTfrSalari"
        @input="removeError('accantonamentiTfrSalari')"
      />
      <FormInputSelectWidget
        class="col-sm-6 col-lg-3 mb-3"
        label="Gestione del personale"
        v-model.number="settings.gestionePersonale"
        :options="gestionePersonaleOpts"
        optionValue="value"
      />
    </div>

    <div class="row py-4 border-bottom">
      <h4 class="h2 col-12">Valutazione azienda - Venture Capital Method</h4>
      <div class="col-sm-6 col-lg-3 mb-3">
        <FormInputTextWidget
          label="Multiplo"
          type="number" :min="0"
          v-model.number="settings.ventureCapitalMultiplo"
        />
        <b-button variant="link" id="mulitple-popover-trigger" class="p-0 text-muted">
          <i class="fas fa-info-circle mr-1"></i>
          <span class="small ">Che cos'è?</span>
        </b-button>
        <b-popover target="mulitple-popover-trigger" triggers="hover" placement="right">
          <template v-slot:title>Multiplo</template>
          <small>Il Multiplo è il rapporto EV/EBITDA (Enterprise Value / EBITDA) calcolato come media degli EV/EBITDA delle aziende appartenenti allo stesso settore che sono state sottoposte a valutazione in Europa. I multipli vengono pubblicati annualmente</small>
        </b-popover>
      </div>

      <div class="col-sm-6 col-lg-3 mb-3">
        <FormInputPercentageWidget
          label="Attualizzazione"
          v-model="settings.ventureCapitalAttualizzazione"
        />
        <b-button variant="link" id="attualizzazione-popover-trigger" class="p-0 text-muted">
          <i class="fas fa-info-circle mr-1"></i>
          <span class="small ">Che cos'è?</span>
        </b-button>
        <b-popover target="attualizzazione-popover-trigger" triggers="hover" placement="right">
          <template v-slot:title>Attualizzazione</template>
          <small>Il Tasso di attualizzazione dipende dallo stadio di sviluppo dell’azienda e rappresenta il rischio dell’investimento nel capitale dell’azienda stessa. Indicativamente il tasso viene determinato come segue: DEVELOPMENT - 70/80%, STARTUP - 60/70%, GROWTH  - 65/55%, EXPANSION - 60/40%, MATURITY - 50/30%</small>
        </b-popover>
      </div>
    </div>

    <div class="row py-4">
      <h4 class="h2 col-12">Prevenzione crisi d'impresa</h4>
      <div class="col-sm-12 col-lg-8 mb-3">
        <FormInputSelectWidget
          label="Codice ATECO"
          v-model="settings.categoria"
          :options="companyCategories"
          :errorMsg="errorHash.categoria"
          @input="removeError('categoria')"
          optionValue="value"
          />
          <b-button variant="link" id="category-popover-trigger" class="p-0 text-muted">
            <i class="fas fa-info-circle mr-1"></i>
            <span class="small ">Che cos'è?</span>
          </b-button>
          <b-popover target="category-popover-trigger" triggers="hover" placement="right">
            <template v-slot:title>Codice ATECO</template>
            <small>Specificare il codice ATECO serve per i calcoli relativi alla prevenzione della crisi d'impresa.</small>
          </b-popover>
      </div>

    </div>

    <div class="col-12 col-lg-2 offset-lg-10 text-right mt-3">
      <button class="btn btn-primary btn-block" type="submit">
        Salva dati
      </button>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';
import { BButton, BPopover } from 'bootstrap-vue';

export default {
  name: 'operative-settings-form',
  mixins: [validateMixin],
  components: {
    BButton,
    BPopover,
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget.vue'),
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => ({
        isPrimary: false,
        inizioPrevisionale: null,
        durataPrevisionale: 5,
        mesiDiBudget: 6,

        previsioneRicaviProgetti: 0,
        previsioneRicaviAliquotaIvaProgetti: 22,
        previsioneCostiProgetti: 0,
        previsioneCostiAliquotaIvaProgetti: 22,
        previsioneCostiAliquotaRitenutaProgetti: 10,

        inflazioneCosti: 0,
        inflazioneRicavi: 0,

        maggiorazioneSuperAmmortamento: 40,
        maggiorazioneIperAmmortamento: 150,

        periodicitaIva: 'three-month',
        aliquotaIres: 24,
        aliquotaIrap: 3.9,
        irapDeducibile: 10,
        percentualePrimoAnticipo: 40,
        percentualeSecondoAnticipo: 60,

        tassoMedioCreditoOperativo: 4,

        oneriSocialiSuRal: 30,
        trattenuteInpsMedie: 33,
        accantonamentiTfrSalari: 8,
        gestionePersonale: 'analytic',

        ventureCapitalMultiplo: null,
        ventureCapitalAttualizzazione: null,

        categoria: null,
      }),
    },
    hasProjects: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    vatCycleOptions () {
      return [
        {
          value: 'one-month',
          label: 'Mensile',
        },
        {
          value: 'three-month',
          label: 'Trimestrale',
        },
      ];
    },
    companyCategories () {
      return [
        {
          value: null,
          label: 'Seleziona un valore',
        },
        {
          value: 'A',
          label: '(A) Agricoltura silvicoltura e pesca',
        },
        {
          value: 'B-C-D',
          label: '(B) Estrazione, (C) manifattura, (D) produzione energia/gas',
        },
        {
          value: 'E-D',
          label: '(E) Forniture acqua reti fognarie e rifiuti, (D) trasmissione energia/gas',
        },
        {
          value: 'F41',
          label: '(F41) Costruzione di edifici',
        },
        {
          value: 'F42-F43',
          label: '(F42) Ingegneria civile,(F43) costruzioni specializzate',
        },
        {
          value: 'G45-G46-D',
          label: '(G45) Commercio autoveicoli,(G46) commercio ingrosso,(D) distribuzione energia/gas',
        },
        {
          value: 'H-I55',
          label: '(H) Trasporto e magazzinaggio,(I55) hotel',
        },
        {
          value: 'JMN',
          label: '(JMN) Servizi alle imprese B2B',
        },
        {
          value: 'PQRS',
          label: '(PQRS) Servizi alle persone',
        },
      ];
    },
    gestionePersonaleOpts () {
      return [
        {
          value: 'simplified',
          label: 'Metodo Semplificato',
        },
        {
          value: 'analytic',
          label: 'Metodo Analitico'
        }
      ]
    },
    budgetMonthsOpts () {
      return [
        {
          value: 6,
          label: '6',
        },
        {
          value: 7,
          label: '7',
        },
        {
          value: 8,
          label: '8',
        },
        {
          value: 9,
          label: '9',
        },
        {
          value: 10,
          label: '10',
        },
        {
          value: 11,
          label: '11',
        },
        {
          value: 12,
          label: '12',
        },
      ];
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (this.edit && !this.settings.inizioPrevisionale) {
        this.addError('Inserire un valore per l\'inizio del previsionale', 'inizioPrevisionale');
      }

      if (!this.settings.durataPrevisionale || this.settings.durataPrevisionale < 3 || this.settings.durataPrevisionale > 5) {
        this.addError('La durata del previsionale deve essere compresa tra 3 e 5 anni', 'durataPrevisionale');
      }

      if (!this.settings.inflazioneCosti && this.settings.inflazioneCosti !== 0) {
        this.addError('Inserire un valore per questo campo', 'inflazioneCosti');
      }

      if (!this.settings.inflazioneRicavi && this.settings.inflazioneRicavi !== 0) {
        this.addError('Inserire un valore per questo campo', 'inflazioneRicavi');
      }

      if (this.hasProjects && !this.settings.previsioneRicaviProgetti && this.settings.previsioneRicaviProgetti !== 0) {
        this.addError('Inserire un valore previsionale per i ricavi da progetti', 'previsioneRicaviProgetti');
      }
      if (this.hasProjects && !this.settings.previsioneCostiProgetti && this.settings.previsioneCostiProgetti !== 0) {
        this.addError('Inserire un valore previsionale per i costi da progetti', 'previsioneCostiProgetti');
      }

      if (!this.settings.maggiorazioneSuperAmmortamento && this.settings.maggiorazioneSuperAmmortamento !== 0) {
        this.addError('Inserire un valore per questo campo', 'maggiorazioneSuperAmmortamento');
      }

      if (!this.settings.maggiorazioneIperAmmortamento && this.settings.maggiorazioneIperAmmortamento !== 0) {
        this.addError('Inserire un valore per questo campo', 'maggiorazioneIperAmmortamento');
      }

      if (!this.settings.aliquotaIres && this.settings.aliquotaIres !== 0) {
        this.addError('Inserire un valore per questo campo', 'aliquotaIres');
      }

      if (!this.settings.aliquotaIrap && this.settings.aliquotaIrap !== 0) {
        this.addError('Inserire un valore per questo campo', 'aliquotaIrap');
      }

      if (!this.settings.irapDeducibile && this.settings.irapDeducibile !== 0) {
        this.addError('Inserire un valore per questo campo', 'irapDeducibile');
      }

      if (!this.settings.percentualePrimoAnticipo && this.settings.percentualePrimoAnticipo !== 0) {
        this.addError('Inserire un valore per questo campo', 'percentualePrimoAnticipo');
      }

      if (!this.settings.percentualeSecondoAnticipo && this.settings.percentualeSecondoAnticipo !== 0) {
        this.addError('Inserire un valore per questo campo', 'percentualeSecondoAnticipo');
      }

      if (!this.settings.tassoMedioCreditoOperativo && this.settings.tassoMedioCreditoOperativo !== 0) {
        this.addError('Inserire un valore per questo campo', 'tassoMedioCreditoOperativo');
      }

      if (!this.settings.oneriSocialiSuRal && this.settings.oneriSocialiSuRal !== 0) {
        this.addError('Inserire un valore per questo campo', 'oneriSocialiSuRal');
      }

      if (!this.settings.trattenuteInpsMedie && this.settings.trattenuteInpsMedie !== 0) {
        this.addError('Inserire un valore per questo campo', 'trattenuteInpsMedie');
      }

      if (!this.settings.accantonamentiTfrSalari && this.settings.accantonamentiTfrSalari !== 0) {
        this.addError('Inserire un valore per questo campo', 'accantonamentiTfrSalari');
      }

      if (!this.settings.categoria) {
        this.addError('Inserire un valore per questo campo', 'categoria');
      }

      return !this.hasErrors;
    },
    saveSettings () {
      if (!this.validate()) {
        return;
      }

      const settings = {
        durataPrevisionale: 5,
        mesiDiBudget: 6,

        previsioneRicaviProgetti: 0,
        previsioneRicaviAliquotaIvaProgetti: 22,
        previsioneCostiProgetti: 0,
        previsioneCostiAliquotaIvaProgetti: 22,
        previsioneCostiAliquotaRitenutaProgetti: 10,

        inflazioneCosti: 0,
        inflazioneRicavi: 0,

        maggiorazioneSuperAmmortamento: 40,
        maggiorazioneIperAmmortamento: 150,

        periodicitaIva: 'three-month',
        aliquotaIres: 24,
        aliquotaIrap: 3.9,
        irapDeducibile: 10,
        percentualePrimoAnticipo: 40,
        percentualeSecondoAnticipo: 60,

        tassoMedioCreditoOperativo: 4,

        oneriSocialiSuRal: 30,
        trattenuteInpsMedie: 33,
        accantonamentiTfrSalari: 8,

        ventureCapitalMultiplo: null,
        ventureCapitalAttualizzazione: null,

        categoria: null,
      };

      this.$emit('submitForm', { ...settings, ...this.settings });
    },
  },
};

</script>

<style lang="scss">

.settings-form {
  .form-label {
    font-size: 10px;
    margin-bottom: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

</style>
